export const FETCH_CGU_CONTENT = 'FETCH_CGU_CONTENT';
export const UPDATE_CGU_CONTENT = 'UPDATE_CGU_CONTENT';
